/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const SecurityRateUpdateJsonApiModel = {
  id: "",
  "created-at": "",
  security: {
    jsonApi: "hasOne",
    type: "securities",
  },
  rate: "",
  "as-of-date": "",
};
